__turbopack_context__.v({
  "dropdown": "jIRzyq_dropdown",
  "dropdownItem": "jIRzyq_dropdownItem",
  "dropdownSlideIn": "jIRzyq_dropdownSlideIn",
  "icon": "jIRzyq_icon",
  "markdownIconButton": "jIRzyq_markdownIconButton",
  "markdownIconButtonOpen": "jIRzyq_markdownIconButtonOpen",
  "markdownIconContainer": "jIRzyq_markdownIconContainer",
});
